$(document).ready(function () {
    $('[data-module="collapse-body"]').hide();
    $('[data-action="collapse-deploy"]').click(function () {
        $(this).siblings('[data-module="collapse-body"]').slideToggle();
        $(this).children('.icon-elem').toggleClass('animate');
    });

    $('[data-action="search-deployer"]').on('click', function(){
        $('[data-module="search-deploy"]').delay(4000).toggleClass('active');
        $(this).toggleClass('inactive').toggleClass('icon-elem--search').toggleClass('icon-elem--close');
    });

    $('[data-action="sidebar-deployer"]').on('click', function(){
        $('[data-module="sidebar-body"]').delay(4000).toggleClass('deployed');
    });

    $('[data-module="max-counter"]').keyup(function(){
        var $textarea = $(this),
        maxlength = parseInt($textarea.attr('maxlength')),
        valuelength = $textarea.val().length;

        $('#max-dead').text(maxlength - valuelength);
    })
    if (Modernizr.mq('(max-width: 480px)')) {
        $('.step-box__button').removeClass('tablet-up').addClass('tablet-down');
    }else{
        $('.step-box__button').removeClass('tablet-down').addClass('tablet-up');
    }

    var lastId,
        topMenu = $(".sidebar__indice"),
        topMenuHeight = topMenu.outerHeight(),
        // All list items
        menuItems = topMenu.find("a"),
        // Anchors corresponding to menu items
        scrollItems = menuItems.map(function(){
            var item = $($(this).attr("href"));
            if (item.length) { return item; }
        });

    $(window).scroll(function(){
        // Get container scroll position
        var fromTop = $(this).scrollTop()+topMenuHeight;

        // Get id of current scroll item
        var cur = scrollItems.map(function(){
            if ($(this).offset().top < fromTop)
            return this;
        });
        // Get the id of the current element
        cur = cur[cur.length-1];
        var id = cur && cur.length ? cur[0].id : "";

        if (lastId !== id) {
            lastId = id;
            // Set/remove active class
            menuItems
                .parent().removeClass("sidebar__item--current")
                .end().filter("[href='#"+id+"']").parent().addClass("sidebar__item--current");
        }
    });
    
    $('[data-module="audio-js"]').audio();
    $('[data-module="stickyParent"]').stick_in_parent();
});